module.exports = __webpack_public_path__ + "img/export-excel.81cf4cd6.svg";